import React from 'react'
import Pt from 'prop-types'
import debounce from 'lodash/debounce'
import { Broadcast, Subscriber } from 'react-broadcast'

export default class Dimensions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dimensions: {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
      },
    }

    this.updateDimensions = debounce(this.updateDimensions)
  }

  componentWillMount() {
    this.updateDimensions()
  }

  componentDidMount() {
    this.updateDimensions()

    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    this.setState({
      dimensions: {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
      },
    })
  }

  render() {
    return (
      <Broadcast channel="windowDimensions" value={this.state.dimensions}>
        {this.props.children}
      </Broadcast>
    )
  }
}

Dimensions.propTypes = {
  children: Pt.node.isRequired,
}

export const Subscribe = ({ children, ...props }) => (
  <Subscriber {...props} channel="windowDimensions">
    {children}
  </Subscriber>
)

Subscribe.propTypes = {
  children: Pt.func.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Dimensions.jsx